import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppointmentState } from 'src/components/provider/AppointmentProvider';

const OptumTermsOfUse = () => {
  const { t } = useTranslation();
  const { medicalGroupName } = useAppointmentState();

  // applies correct preposition in the Spanish translation vs English
  const brand = t('BRAND', { brandName: medicalGroupName });
  return (
    <div>
      <p>
        <u>{t('OBC_H1')}</u>
      </p>
      <p>{t('OBC_H1_P1', { brand })}</p>
      <p>{t('OBC_H1_P2')}</p>
      <p>{t('OBC_H1_P3')}</p>
      <p>{t('OBC_H1_P4')}</p>
      <p>
        <strong>{t('OBC_H2')}</strong>
      </p>
      <p>{t('OBC_H2_P1')}</p>
      <ul>
        <li>{t('OBC_H2_BULLET_1')}</li>
        <li>{t('OBC_H2_BULLET_2')}</li>
      </ul>
      <p>
        <strong>{t('OBC_H3')}</strong>
      </p>
      <p>{t('OBC_H3_P1')}</p>
      <ul>
        <li>{t('OBC_H3_BULLET_1')}</li>
        <li>{t('OBC_H3_BULLET_2')}</li>
        <li>{t('OBC_H3_BULLET_3')}</li>
        <li>{t('OBC_H3_BULLET_4')}</li>
      </ul>
      <p>
        <strong>{t('OBC_H4')}</strong>
      </p>
      <ol>
        <li>{t('OBC_H4_LI_1')}</li>
        <li>{t('OBC_H4_LI_2')}</li>
        <li>{t('OBC_H4_LI_3')}</li>
        <li>{t('OBC_H4_LI_4')}</li>
        <li>{t('OBC_H4_LI_5')}</li>
        <li>{t('OBC_H4_LI_6')}</li>
        <li>{t('OBC_H4_LI_7')}</li>
        <li>{t('OBC_H4_LI_8')}</li>
        <li>{t('OBC_H4_LI_9')}</li>
        <li>{t('OBC_H4_LI_10')}</li>
      </ol>
    </div>
  );
};

export default OptumTermsOfUse;
